import { createOpenStore } from "stores/createOpenStore";

export type Guide = "overview" | "canvas";

/** Kept across logout (AuthProvider), so each guide opens once per browser. */
export const GUIDE_SEEN_KEYS: Record<Guide, string> = {
  overview: "mycorr.overviewGuideSeen",
  canvas: "mycorr.canvasGuideSeen",
};

export interface OpenGuide {
  guide: Guide;
  /** Asked for (Help, the Overview's tour button): straight in, past any welcome. */
  direct: boolean;
}

export const useGuideStore = createOpenStore<OpenGuide>();

// Noted by the Overview for someone who has never opened a model, for the
// tab's session: Canvas basics opens by itself only on such a first run.
const FIRST_RUN_KEY = "mycorr.firstRun";
export const noteFirstRun = (): void => {
  try {
    sessionStorage.setItem(FIRST_RUN_KEY, "1");
  } catch {
    // Unnoted, Canvas basics waits for Help.
  }
};
export const isFirstRun = (): boolean => {
  try {
    return sessionStorage.getItem(FIRST_RUN_KEY) === "1";
  } catch {
    return false;
  }
};

export const openGuide = (guide: Guide): void =>
  useGuideStore.getState().show({ guide, direct: true });

export function showGuideOnFirstVisit(guide: Guide): void {
  try {
    if (localStorage.getItem(GUIDE_SEEN_KEYS[guide])) return;
  } catch {
    // Storage blocked: it could not remember a dismissal, so it would open on every visit.
    return;
  }
  useGuideStore.getState().show({ guide, direct: false });
}

/** Seen once closed, not once opened: a guide a reload interrupts opens again. */
export function closeGuide(guide: Guide): void {
  try {
    localStorage.setItem(GUIDE_SEEN_KEYS[guide], "1");
  } catch {
    // Unremembered, it opens again next visit.
  }
  useGuideStore.getState().close();
}
